import React from 'react';
import styles from './TabContent.module.scss';

function TabContent({ children }) {
  return (
    <div className={styles.tabContent}>
      {children}
    </div>
  );
}

export default TabContent; 